/**
 * @generated SignedSource<<57a57d7aba19a27e0454026d7aade2ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$data = {
  readonly fieldSets: {
    readonly __id: string;
    readonly " $fragmentSpreads": FragmentRefs<"columnPicker_issueViewChildIssuesPanel" | "ui_nativeIssueTable_NativeIssueTable_columns">;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "amountOfColumns"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "fieldSetSelectedState": "SELECTED"
          }
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "amountOfColumns"
        }
      ],
      "concreteType": "JiraIssueSearchFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_nativeIssueTable_NativeIssueTable_columns"
        },
        {
          "kind": "FragmentSpread",
          "name": "columnPicker_issueViewChildIssuesPanel"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraFieldSetView"
};

(node as any).hash = "a401a101b7623be28774deda40edbce5";

export default node;
